import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../../"

const selectUi = (state: RootState) => state.ui

export const selectSidebarCollapsed = createSelector(selectUi, (ui) => ui.sidebarCollapsed)